import clientLayout from '@/layout/clientLayout.vue'
const clientRouter = {
  path: '/',
  component: clientLayout,
  children: [
    {
      path: '/',
      name: '首页',
      component: () => import('@/client/home/index')
    },
    {
      path: '/order/exp',
      name: '快递下单',
      component: () => import('@/client/home/placeAnOrder/exp/index')
    },
    {
      path: '/order/fba',
      name: 'FBA下单',
      component: () => import('@/client/home/placeAnOrder/fba/index')
    },
    {
      path: '/order/air',
      name: '空运下单',
      component: () => import('@/client/home/placeAnOrder/air/index')
    },
    {
      path: '/order/sea',
      name: '海运下单',
      component: () => import('@/client/home/placeAnOrder/sea/index')
    }
  ]
}
export default clientRouter
